import React, { useEffect, useRef, useState } from "react";
import { ActivityIndicator, Platform, TouchableOpacity, View } from 'react-native';
import BoilerPlate from "../boilerPlate/BoilerPlate";
import { ColorTokens, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, TypographyTypeDLS } from "@voltmoney/schema";
import Typography from "../../typography/Typography";
import { OtpInput } from "../OtpInput/OtpInput";
import Space from "../../space/Space";
import * as Animatable from 'react-native-animatable';
import { getParameters } from "../utils";
const OtpVerifypage = ({ height, phoneNumber, charLimit = 6, editAction, action, otpAction, caption, state, resendTimer = 15, onChangeText, extraSpace, triggerAction }) => {
    const inputRef = useRef(null);
    const [otpLimitExceeded, setOtpLimitExceeded] = useState(false);
    const [isErrorState, setIsErrorState] = useState(false);
    const [isSuccessState, setIsSuccessState] = useState(false);
    const [showTimer, setShowTimer] = useState(false);
    const [seconds, setSeconds] = useState(resendTimer);
    const [isRunning, setIsRunning] = useState(false);
    const [successText, setSuccessText] = useState(false);
    const [loader, setLoader] = useState(false);
    const [btnLoader, setbtnLoader] = useState(false);
    let isDarkMode = null;
    if (Platform.OS === 'web') {
        let params = getParameters(window.location.href);
        isDarkMode = params.isDarkMode;
    }
    useEffect(() => {
        setIsRunning(true);
    }, []);
    useEffect(() => {
        if (successText) {
            setTimeout(() => {
                setSuccessText(false);
            }, 3000);
        }
    }, [showTimer, seconds]);
    useEffect(() => {
        let timer;
        if (isRunning && seconds > 0) {
            timer = setInterval(() => {
                setSeconds((prevSeconds) => prevSeconds - 1);
            }, 1000);
        }
        else if (seconds === 0) {
            setIsRunning(false);
        }
        return () => clearInterval(timer);
    }, [isRunning, seconds]);
    useEffect(() => {
        if (state === 'SUCCESS')
            setIsSuccessState(true);
        else if (state === 'ERROR')
            setIsErrorState(true);
        else if (state === 'DISABLED')
            setOtpLimitExceeded(true);
        else {
            setIsErrorState(false);
            setOtpLimitExceeded(false);
        }
    }, [state]);
    const handleReset = () => {
        setSeconds(resendTimer);
        setIsRunning(true);
        setLoader(false);
        setIsErrorState(false);
        setIsSuccessState(true);
    };
    const handleTextChange = async (text) => {
        if (onChangeText) {
            onChangeText(text);
        }
        if (text.length === charLimit && text[text.length - 1] >= '0' && text[text.length - 1] <= '9') {
            if (action && triggerAction && !otpLimitExceeded) {
                setbtnLoader(true);
                setIsErrorState(false);
                await triggerAction({
                    ...action,
                    payload: {
                        ...action.payload,
                        value: text,
                    },
                });
                setbtnLoader(false);
            }
        }
        else {
            setIsErrorState(false);
            setLoader(false);
        }
    };
    const renderContent = () => {
        return (React.createElement(View, { style: { marginTop: Platform.OS === 'web' ? 24 : 56, padding: 16 } },
            React.createElement(Typography, { label: "Enter OTP", typeDLS: TypographyTypeDLS.H3S, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night }),
            React.createElement(View, { style: { marginTop: 4, flexDirection: 'row' } },
                React.createElement(Typography, { label: "6-digit OTP sent to ", typeDLS: TypographyTypeDLS.B1R, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal }),
                React.createElement(Typography, { label: `${phoneNumber.substring(3)}`, typeDLS: TypographyTypeDLS.B1S, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal }),
                React.createElement(TouchableOpacity, { onPress: () => {
                        if (editAction)
                            triggerAction(editAction);
                    } },
                    React.createElement(Typography, { id: "txt_loginScreen_edit", label: "   Edit", typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Primary_100 }))),
            React.createElement(View, null,
                React.createElement(View, { style: { marginTop: 24 } },
                    React.createElement(OtpInput, { id: 'tf_loginScreen_otp', numberOfDigits: charLimit, ref: inputRef, onTextChange: handleTextChange, editable: !btnLoader, isDarkMode: isDarkMode ? true : false, focusColor: isErrorState ? 'red' : 'blue', theme: {
                            inputsContainerStyle: {
                                width: 47,
                                height: 47,
                                borderRadius: 0,
                            },
                            pinCodeContainerStyle: { borderRadius: 8, borderColor: isDarkMode ? 'white' : '#DFDFDE' },
                            pinCodeTextStyle: isDarkMode ? { fontSize: 15, color: 'white' } : { fontSize: 15 },
                            containerStyle: { width: 310 },
                        } }),
                    React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                    React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                    React.createElement(View, { style: { marginTop: 6 } }),
                    btnLoader && !isErrorState && !otpLimitExceeded && React.createElement(View, { style: { flexDirection: 'row' } },
                        React.createElement(ActivityIndicator, { color: "#1434CB", size: "small" }),
                        React.createElement(View, { style: { marginLeft: 6 } },
                            React.createElement(Typography, { label: "Verifying OTP", fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Primary_100, lineHeight: 20, fontFamily: FontFamilyTokens.Inter }))),
                    isErrorState && inputRef?.current?.clear(),
                    btnLoader || (!isErrorState && !otpLimitExceeded) && (React.createElement(View, { style: { height: extraSpace } })),
                    (isErrorState || otpLimitExceeded) && (React.createElement(View, { style: {} },
                        React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
                            React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.System_Error, label: caption?.error ? caption?.error : "" })))),
                    isSuccessState && (React.createElement(View, { style: {} },
                        React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.Success_100, label: caption?.success ? caption?.success : "" }))),
                    React.createElement(View, { style: {
                            marginTop: 16,
                            flexDirection: 'row',
                            width: '100%'
                        } },
                        React.createElement(View, null,
                            React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal, label: "Didn't receive OTP?" })),
                        React.createElement(TouchableOpacity, { disabled: otpLimitExceeded, style: { marginLeft: 8 }, onPress: () => {
                                if ((seconds === 0 && !otpLimitExceeded)) {
                                    setSuccessText(true);
                                    setShowTimer(false);
                                    handleReset();
                                    //@ts-ignore
                                    inputRef?.current?.clear();
                                    handleTextChange('');
                                    if (triggerAction) {
                                        triggerAction(otpAction);
                                    }
                                }
                                else
                                    setShowTimer(true);
                            } },
                            React.createElement(Typography, { id: 'txt_loginScreen_resendOtp', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, color: (seconds === 0 && !otpLimitExceeded)
                                    ? ColorTokens.Primary_100
                                    : isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal, label: 'Resend OTP' }))),
                    !successText && showTimer && seconds > 0 && (React.createElement(View, { style: { marginTop: 10 } },
                        React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
                            React.createElement(Typography, { label: `Please wait for ${seconds}s to resend OTP`, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, lineHeight: 20, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night })))),
                    successText &&
                        React.createElement(View, { style: { marginTop: 10 } },
                            React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
                                React.createElement(Typography, { label: `OTP has been resent.`, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, lineHeight: 20, color: ColorTokens.Secondary_100 })))))));
    };
    return (React.createElement(BoilerPlate, { height: height, backgroundColor: isDarkMode ? ColorTokens.DARK_MODE : ColorTokens.White },
        React.createElement(React.Fragment, null, renderContent())));
};
export default OtpVerifypage;
